import axios from "axios";

export default {
  namespaced: true,
  strict: true,
  state: {
    UserId: "",
    WorkSpaceName: "",
    WorkSpaceId: "",
    isNewUser: true,
    success: false,
    getWorkspacesError: false,
  },
  getters: {
    getIsNewUser(state) {
      return state.isNewUser;
    },
    getWorkSpaceName(state) {
      return state.WorkSpaceName;
    },
    getWorkSpaceId(state) {
      return state.WorkSpaceId;
    },
    getUserId(state) {
      return state.UserId;
    },
    getJoinWorkSpaceSuccess(state) {
      return state.success;
    },
    getWorkspacesError(state) {
      return state.getWorkspacesError;
    },
  },
  mutations: {
    setWorkSpace(state, payload) {
      state.UserId = payload.userID;
      state.WorkSpaceId = payload.workspaceID;
      state.WorkSpaceName = payload.workspaceName;
      state.isNewUser = payload.newUser;
    },
    setJoinedWorkspaceSuccess(state, payload) {
      state.success = payload;
    },
    setGetWorkspacesError(state, payload) {
      state.getWorkspacesError = payload;
    },
  },
  actions: {
    async getJoinWorkspace(state, payload) {
      //call GET on /join
      try {
        let data = {
          Token: payload.Token,
        };
        await axios.get("join", { params: data }).then((res) => {
          if (res.status == 200) {
            state.commit("setWorkSpace", res.data);
            state.commit("setGetWorkspacesError", false);
          } else {
            //set error state
            state.commit("setGetWorkspacesError", true);
          }
        });
      } catch (err) {
        //display "We're Sorry" page
        state.commit("setGetWorkspacesError", true);
      }
    },
    async postJoinWorkspace(state, payload) {
      //call POST on /join
      try {
        let json = {
          workspaceID: payload.workspaceID,
          password: payload.password,
        };
        await axios.post("join", json).then((res) => {
          if (res.status == 200) {
            state.commit("setJoinedWorkspaceSuccess", true);
          }
        });
      } catch (err) {
        state.commit("setJoinedWorkspaceSuccess", false);
      }
    },
    resetState(state) {
      state.commit("setWorkSpace", {
        UserId: "",
        WorkSpaceName: "",
        WorkSpaceId: "",
        isNewUser: true,
        success: false,
        getWorkspacesError: false,
      });
    },
  },
};
